<template>
  <div>
    <button class="btn btn-default" type="button" name="button" v-on:click="shown = 'client'">Client</button>
    <button class="btn btn-default" type="button" name="button" v-on:click="shown = 'contractor'">Contractor</button>
    <div v-if="shown == 'contractor'">
      <h3>Contractor Projects</h3>
      <p v-for="project in contractor_projects">
        <router-link :to="{path: 'projects/' + project.id}">{{ project.title }}</router-link>
      </p>
      <div v-if="contractor_projects.length == 0">
        <loading></loading>
      </div>
    </div>
    <div v-if="shown == 'client'">
      <h3>Client Projects</h3>
      <p v-for="project in client_projects">
        <router-link :to="{path: 'projects/' + project.id}">{{ project.title }}</router-link>
      </p>
      <div v-if="client_projects.length == 0">
        <loading></loading>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authService from '../auth'
import config from '../config'
import Loading from './Loading.vue'

export default {
  name: 'projects',
  created () {
    authService.getToken().then(token => {
      axios.get(`${config.base_url}/projects`, {headers: {'Authorization': token}}).then(res => {
        this.client_projects = res.data.projects.filter(project => project.role === 'client')
        this.contractor_projects = res.data.projects.filter(project => project.role === 'contractor')
      })
    })
  },
  data () {
    return {
      auth: authService,
      shown: 'client',
      client_projects: [],
      contractor_projects: []
    }
  },
  components: {
    Loading
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Projects.vue?453a106a